import { render, staticRenderFns } from "./AffiliationInvite.vue?vue&type=template&id=e09057e8&scoped=true&"
import script from "./AffiliationInvite.vue?vue&type=script&lang=js&"
export * from "./AffiliationInvite.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationInvite.vue?vue&type=style&index=0&id=e09057e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09057e8",
  null
  
)

export default component.exports